import { Box } from '@mui/material';
import { PreviewButton } from './PreviewButton';
import { SaveButton } from './SaveButton';

export function ReportDefinitionActions() {
  return (
    <Box display="flex" justifyContent="flex-start" gap={2}>
      <PreviewButton />
      <SaveButton />
    </Box>
  );
}
